import React, { Component } from 'react';
import './App.css';
import firebase from 'firebase';

import Page, { Grid, GridColumn } from '@atlaskit/page';
import Avatar from '@atlaskit/avatar';
import TextField from '@atlaskit/field-text';
import FieldTextArea from '@atlaskit/field-text-area';
import Calendar from '@atlaskit/calendar';
import Select from '@atlaskit/select';
import { TimePicker } from '@atlaskit/datetime-picker';
import Button from '@atlaskit/button';

import AkinSocks from './akin-socks.jpg';
import BrossSocks from './bross-socks.jpg';
import EligulSocks from './eligul-socks.jpg';
import ErbosSocks from './erbos-socks.jpg';
import GonultasSocks from './gonultas-socks.jpg';
import GuleclerSocks from './gulecler_socks.jpg';
import HobbySocks from './Hobby_Socks.jpg';
import OralSocks from './oral_Socks.jpg';
import OztasSocks from './Oztas_Socks.jpg';
import PaktasSocks from './Paktas_Socks.jpg';
import RoyalSocks from './Ro-Yal_Socks.jpg';
import SerifSocks from './Serif_Socks.jpg';
import SevalSocks from './Sev-Al_Socks.jpg';
import TempoSocks from './Tempo_Socks.jpg';
import UlasSocks from './Ulas_Socks.jpg';
import UltraSocks from './Ultra_Socks.jpg';


var config = {
  apiKey: "AIzaSyDl_sQ_CZ3qspXZSIl2vd0qGwavTEmMuSQ",
  authDomain: "booking-3bf24.firebaseapp.com",
  databaseURL: "https://booking-3bf24.firebaseio.com",
  projectId: "booking-3bf24",
  storageBucket: "booking-3bf24.appspot.com",
  messagingSenderId: "386522657062"
};
firebase.initializeApp(config);


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      time: null,
      name: null,
      company: null,
      email: null,
      phone: null,
      notes: null,
    };
  }

  render() {
    return (
      <div style={{marginTop:'80px'}}>
        <Page>
          <Grid>
            {this.renderCustomers()}
            {this.renderCalendar()}
            {this.renderBookingForm()}
          </Grid>
        </Page>
      </div>
    );
  }

  renderCustomers() {
    const customers = [
      'AKIN SOCKS',
      'BROSS SOCKS',
      'ELIGUL SOCKS',
      'ERBOS SOCKS',
      'GONULTAS SOCKS',
      'GULECLER SOCKS',
      'HOBBY SOCKS',
      'ORAL SOCKS',
      'OZTAS SOCKS',
      'PAKTAS SOCKS',
      'RO-YAL SOCKS',
      'SERIF SOCKS',
      'SEV-AL SOCKS',
      'TEMPO SOCKS',
      'ULAS SOCKS',
      'ULTRA SOCKS'
    ];

    const avatars = [
      AkinSocks,
      BrossSocks,
      EligulSocks,
      ErbosSocks,
      GonultasSocks,
      GuleclerSocks,
      HobbySocks,
      OralSocks,
      OztasSocks,
      PaktasSocks,
      RoyalSocks,
      SerifSocks,
      SevalSocks,
      TempoSocks,
      UlasSocks,
      UltraSocks
    ];

    const selectItems = customers.map((v, i) => {
      return {
        content: (
          <div style={{display:'flex',alignItems:'center'}}>
            <Avatar src={avatars[i]} />
            <div style={{marginLeft:'10px'}}>{v}</div>
          </div>
        ),
        label: v,
        value: v,
      }
    });

    return (
      <GridColumn medium={8}>
        <b>Select customers</b>
        <div style={{display:'flex',flexDirection:'column',marginTop:'10px'}}>
          <Select options={selectItems}
            placeholder='Select customers'
            autoFocus
            isDefaultOpen
            isMulti
            getOptionLabel={l => l.content}
            onChange={values => this.setState({ customers: values.map(v => v.label) })} />
        </div>
      </GridColumn>
    );
  }

  renderCalendar() {
    return (
      // <GridColumn medium={4}>
      //   <Calendar />
      // </GridColumn>
      <GridColumn medium={4}>
        <b>Choose time</b>
        <div style={{marginTop:'10px'}}>
          <TimePicker
              // autoFocus
              // defaultIsOpen
              defaultValue="09:00"
              times = {["09:00","09:20",,"09:40","10:00","10:20",,"10:40","11:00","11:20",,"11:40","12:00","12:20",,"12:40","13:00","13:20",,"13:40","14:00","14:20",,"14:40","15:00","15:20",,"15:40","16:00","16:20","16:40"]}
              onChange={val => this.setState({ time: val })}
            />
        </div>
      </GridColumn>
    );
  }

  renderBookingForm() {
    return (
      <GridColumn medium={12}>
        <div style={{marginTop:'80px'}}>
          <b>Fill booking information</b>
          <TextField autoFocus label="Name" shouldFitContainer
            onChange={ev => this.setState({ name: ev.target.value })} />
          <TextField autoFocus label="Company" shouldFitContainer
            onChange={ev => this.setState({ company: ev.target.value })} />
          <TextField label="E-mail" shouldFitContainer
            onChange={ev => this.setState({ email: ev.target.value })} />
          <TextField label="Phone" shouldFitContainer
            onChange={ev => this.setState({ phone: ev.target.value })} />
          <FieldTextArea label="Notes" shouldFitContainer minimumRows={5}
            onChange={ev => this.setState({ notes: ev.target.value })} />
          <div style={{marginTop:'10px'}}>
            <Button appearance='primary' onClick={() => this.handleSave()}>Save</Button>
          </div>
        </div>
      </GridColumn>
    );
  }

  handleSave() {
    firebase.database().ref().push(JSON.stringify(this.state))
      .then(() => window.alert('Booking saved.'));
  }
}

export default App;


/*

  renderProgressTracker() {
    const progressItems = [
      {
        id: 'select-customer',
        label: 'Select Customer',
        percentageComplete: 100,
        status: 'disabled',
        href: '#',
      },
      {
        id: 'choose-datetime',
        label: 'Choose Time',
        percentageComplete: 0,
        status: 'current',
        href: '#',
      },
      {
        id: 'fill-info',
        label: 'Fill Booking Info',
        percentageComplete: 0,
        status: 'unvisited',
        href: '#',
      },
    ];
    return (
      <ProgressTracker items={progressItems} />
    );
  }

*/




// WEBPACK FOOTER //
// ./src/App.js